export default "__VITE_ASSET__fca0d6dd__"